@if (formGroup) {
  <form [formGroup]="formGroup" class="k-flex-layout k-d-flex-col k-gap-6">

    <div class="k-flex-layout k-justify-content-between">
      <div class="k-flex-layout k-gap-8">
        <kendo-label text="Show version">
          <kendo-dropdownlist
            [formControlName]="'version'"
            [data]="versions"
            [valueField]="'version'"
            [textField]="'version'"
            (selectionChange)="onVersionChange($event)"
          ></kendo-dropdownlist>
        </kendo-label>
        <kendo-label text="Model">
          <kendo-dropdownlist
            [formControlName]="'model'"
            [data]="models"
            [textField]="'text'"
            [valueField]="'value'"
          ></kendo-dropdownlist>
        </kendo-label>
        @if (displayedAgent.name !== 'chatbot_agent') {
          <kendo-label text="Status">
            <kendo-dropdownlist
              [formControlName]="'status'"
              [data]="statuses"
              [textField]="'text'"
              [valueField]="'value'"
            ></kendo-dropdownlist>
          </kendo-label>
        }
      </div>
      <div>
        <button
          kendoButton
          themeColor="success"
          [svgIcon]="playIcon"
          (click)="deployHandler()"
          [disabled]="displayedAgent?.version !== currentDeployedAgent?.version"
        >
          Save & Deploy
        </button>
      </div>
    </div>

    <kendo-label text="Description" style="font-weight: bold">
      <kendo-textarea
        [formControlName]="'description'"
        [rows]="3"
        [resizable]="'vertical'"
      ></kendo-textarea>
    </kendo-label>

<!--    @if (containsRagTool) {
      <kendo-label text="Markdowns">
        <kendo-multiselect
          [formControlName]="'chosenMarkdowns'"
          [data]="markdowns"
          [textField]="'itemName'"
          [valueField]="'id'"
        ></kendo-multiselect>
      </kendo-label>
    }-->

    <kendo-label text="Global instruction" style="font-weight: bold">
      <md-editor
        [formControlName]="'globalInstruction'"
        [height]="'300px'"
        [options]="{hideIcons: markdownOptions.hideIcons}"
      />
    </kendo-label>


    <kendo-label text="Instruction" style="font-weight: bold">
      <md-editor
        [formControlName]="'instruction'"
        [height]="'800px'"
        [required]="true"
        [options]="{hideIcons: markdownOptions.hideIcons}"
      />
    </kendo-label>

    <kendo-grid [data]="gridData">
      <kendo-grid-column title="Value" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem>
          <kendo-numerictextbox
            [formControlName]="dataItem.controlName"
            [step]="dataItem.step"
            [min]="dataItem.min"
            [max]="dataItem.max"
          ></kendo-numerictextbox>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="label" title="Control" [width]="240"></kendo-grid-column>
      <kendo-grid-column field="description" title="Description"></kendo-grid-column>
    </kendo-grid>

  </form>
}
